export default __webpack_public_path__ + "static/media/Widowdusk Tunic.33b70473.jpg";